export default {"src":"/_next/static/media/phone-incoming-01.2cdd60c3.svg","height":28,"width":28};